import {sortBy} from 'lodash';
import {orderBy} from 'natural-orderby';
import {useState} from 'react';

import Button from 'components/Button';
import Loading from 'components/Loading';
import InlinePage from 'components/Page/Inline';
import {baseAccIdColumn} from 'components/Table/Cell/AccId';
import TextFilter from 'components/Table/Filter/Text';
import SimpleTable from 'components/Table/Simple';
import KyError from 'components/errors/KyError';
import ReadableWidthTemplate from 'components/templates/ReadableWidth';
import useAppContext from 'conf/AppContext';
import {useGet} from 'helpers/KyHooks';
import {functionString} from 'utils/alleleUtils';

export default function AlleleFunctionPage({id}) {
  const appContext = useAppContext();
  const [geneId, setGeneId] = useState(id);
  const [geneSymbol, setGeneSymbol] = useState(null);
  const {response, error} = useGet('site/alleleFunction', {parseJson: true, cacheResponse: !appContext.isPreview});
  
  const handleGenePick = (value) => () => {
    setGeneId(value.id);
    setGeneSymbol(value.symbol);
    const newUrl = appContext.getCurrentPath().split('?')[0] + '?id=' + value.id;
    appContext.redirect(newUrl, true);
  };

  let body = <Loading />;
  if (error) {
    body = <KyError kyError={error} />;
  } else if (response) {
    const {data = []} = response;
    return (
      <div className="container">
        <div>
          <h1>Allele Functions</h1>
          <InlinePage id="alleleFunctionHeader" showTitle={false} />
          <div className="d-flex flex-wrap" style={{gap: '.4em'}}>
            {sortBy(data, 'symbol').map((g) => (
              <div key={g.id} style={{flex: '0 1 auto'}}>
                <Button actionHandler={handleGenePick(g)} className={(g.id !== geneId ? 'btn-outline-primary' : '')}>{g.symbol}</Button>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-5">
          {geneSymbol && <h2>{geneSymbol}</h2>}
          {geneId && <AlleleList geneId={geneId} geneSymbol={geneSymbol} />}
        </div>
      </div>
    );
  }
  
  return (
    <ReadableWidthTemplate title="Allele Functions">
      {body}
    </ReadableWidthTemplate>
  );
}

function AlleleList({geneId, geneSymbol}) {
  const appContext = useAppContext();
  const {response, error} = useGet(`site/alleleFunction/${geneId}`, {parseJson: true, cacheResponse: !appContext.isPreview});

  let body = null;
  if (error) {
    body = <KyError kyError={error} />;
  } else if (geneId && response) {
    const data = response;

    const columns = [
      {
        id: 'allele',
        Header: 'Allele Name',
        accessor: (row) => row,
        ...baseAccIdColumn,
      },
      {
        id: 'alleleFunction',
        Header: 'Function',
        accessor: (row) => functionString(row),
        Filter: TextFilter,
        sortable: true,
      },
    ];

    const table = (
      <SimpleTable
        columns={columns}
        data={orderBy(data, ['name'])}
        disableExport={false}
        getExportFileName={() => `clinpgx-allele-function-${geneSymbol}`}
      />
    );
    
    body = (
      <div>
        {table}
      </div>
    );
  }
  return body;
}
